'use strict';

// Nav
var SETTINGS = {
    navBarTravelling: false,
    navBarTravelDirection: '',
    navBarTravelDistance: 150
};

// Out advancer buttons
var pnAdvancerLeft = document.getElementById('horizontalNavAdvancerLeft');
var pnAdvancerRight = document.getElementById('horizontalNavAdvancerRight');

var pnProductNav = document.getElementById('horizontalNav');
var pnProductNavContents = document.getElementById('horizontalNavContents');

function determineOverflow(content, container) {
    var containerMetrics = container.getBoundingClientRect();
    var containerMetricsRight = Math.floor(containerMetrics.right);
    var containerMetricsLeft = Math.floor(containerMetrics.left);
    var contentMetrics = content.getBoundingClientRect();
    var contentMetricsRight = Math.floor(contentMetrics.right);
    var contentMetricsLeft = Math.floor(contentMetrics.left);
    if (containerMetricsLeft > contentMetricsLeft && containerMetricsRight < contentMetricsRight) {
        return 'both';
    } else if (contentMetricsLeft < containerMetricsLeft) {
        return 'left';
    } else if (contentMetricsRight > containerMetricsRight) {
        return 'right';
    }
    return 'none';
}

function moveNav(item) {
    if (item) {
        var textPosition = item.getBoundingClientRect();
        // console.log(textPosition);
        var container = pnProductNavContents.getBoundingClientRect().left;
        // console.log(container);
        var distance = textPosition.left - container;
        // console.log(distance);
        pnProductNav.scrollTo({
            top: 0,
            left: distance - 11,
            behavior: 'smooth'
        });
    }
}

pnProductNav.setAttribute('data-overflowing', determineOverflow(pnProductNavContents, pnProductNav));

// Handle the scroll of the horizontal container
var lastKnownScrollPosition = 0;
var ticking = false;

function doSomething() {
    pnProductNav.setAttribute('data-overflowing', determineOverflow(pnProductNavContents, pnProductNav));
}

pnProductNav.addEventListener('scroll', function () {
    lastKnownScrollPosition = window.scrollY;
    if (!ticking) {
        window.requestAnimationFrame(function () {
            doSomething(lastKnownScrollPosition);
            ticking = false;
        });
    }
    ticking = true;
});


pnAdvancerLeft.addEventListener('click', function () {
// If in the middle of a move return
    if (SETTINGS.navBarTravelling === true) {
        return;
    }
  // If we have content overflowing both sides or on the left
    if (determineOverflow(pnProductNavContents, pnProductNav) === 'left' || determineOverflow(pnProductNavContents, pnProductNav) === 'both') {
      // Find how far this panel has been scrolled
        var availableScrollLeft = pnProductNav.scrollLeft;
      // If the space available is less than two lots of our desired distance, just move the whole amount
      // otherwise, move by the amount in the settings
        if (availableScrollLeft < SETTINGS.navBarTravelDistance * 2) {
            pnProductNavContents.style.transform = 'translateX(' + availableScrollLeft + 'px)';
        } else {
            pnProductNavContents.style.transform = 'translateX(' + SETTINGS.navBarTravelDistance + 'px)';
        }
      // We do want a transition (this is set in CSS) when moving so remove the class that would prevent that
        pnProductNavContents.classList.remove('horizontal-nav__nav-content-no-transition');
      // Update our settings
        SETTINGS.navBarTravelDirection = 'left';
        SETTINGS.navBarTravelling = true;
    }
  // Now update the attribute in the DOM
    pnProductNav.setAttribute('data-overflowing', determineOverflow(pnProductNavContents, pnProductNav));
});

pnAdvancerRight.addEventListener('click', function () {
  // If in the middle of a move return
    if (SETTINGS.navBarTravelling === true) {
        return;
    }
  // If we have content overflowing both sides or on the right
    if (determineOverflow(pnProductNavContents, pnProductNav) === 'right' || determineOverflow(pnProductNavContents, pnProductNav) === 'both') {
      // Get the right edge of the container and content
        var navBarRightEdge = pnProductNavContents.getBoundingClientRect().right;
        var navBarScrollerRightEdge = pnProductNav.getBoundingClientRect().right;
      // Now we know how much space we have available to scroll
        var availableScrollRight = Math.floor(navBarRightEdge - navBarScrollerRightEdge);
      // If the space available is less than two lots of our desired distance, just move the whole amount
      // otherwise, move by the amount in the settings
        if (availableScrollRight < SETTINGS.navBarTravelDistance * 2) {
            pnProductNavContents.style.transform = 'translateX(-' + availableScrollRight + 'px)';
        } else {
            pnProductNavContents.style.transform = 'translateX(-' + SETTINGS.navBarTravelDistance + 'px)';
        }
      // We do want a transition (this is set in CSS) when moving so remove the class that would prevent that
        pnProductNavContents.classList.remove('horizontal-nav__nav-content-no-transition');
      // Update our settings
        SETTINGS.navBarTravelDirection = 'right';
        SETTINGS.navBarTravelling = true;
    }
  // Now update the attribute in the DOM
    pnProductNav.setAttribute('data-overflowing', determineOverflow(pnProductNavContents, pnProductNav));
});

pnProductNavContents.addEventListener(
  'transitionend',
  function () {
      // get the value of the transform, apply that to the current scroll position (so get the scroll pos first) and then remove the transform
      var styleOfTransform = window.getComputedStyle(pnProductNavContents, null);
      var tr = styleOfTransform.getPropertyValue('-webkit-transform') || styleOfTransform.getPropertyValue('transform');
      // If there is no transition we want to default to 0 and not null
      var amount = Math.abs(parseInt(tr.split(',')[4], 10) || 0);
      pnProductNavContents.style.transform = 'none';
      pnProductNavContents.classList.add('horizontal-nav__nav-content-no-transition');
      // Now lets set the scroll position
      if (SETTINGS.navBarTravelDirection === 'left') {
          pnProductNav.scrollLeft -= amount;
      } else {
          pnProductNav.scrollLeft += amount;
      }
      SETTINGS.navBarTravelling = false;
  },
  false
);

// Handle setting the currently active link
pnProductNavContents.addEventListener('click', function (e) {
    e.preventDefault();
    if (e.target.closest('.horizontal-nav__nav-link')) {
        // Scroll corresponding section into view
        var section = document.querySelector(e.target.closest('.horizontal-nav__nav-link').getAttribute('href'));
        section.scrollIntoView({
            behavior: 'smooth'
        });
        // Update the navigation and set focus but only after a timeout period so that the smooth scrolling isn't interrupted
        setTimeout(function () {
            var links = [].slice.call(document.querySelectorAll('.horizontal-nav__nav-link'));
            links.forEach(function (item) {
                item.setAttribute('aria-selected', 'false');
            });
            e.target.closest('.horizontal-nav__nav-link').setAttribute('aria-selected', 'true');

            location.hash = section.id;

            // Set focus to the correct section we just scrolled to
            section.focus();
            var isFocused = (document.activeElement === section);
            if (!isFocused) {
                section.setAttribute('tabindex', '-1');
                section.focus();
            }
        }, 500);
    }
});

window.addEventListener('resize', function () {
    pnProductNav.setAttribute('data-overflowing', determineOverflow(pnProductNavContents, pnProductNav));
});

/*!
 * Run a callback function after scrolling has stopped
 * (c) 2017 Chris Ferdinandi, MIT License, https://gomakethings.com
 * @param  {Function} callback The function to run after scrolling
 */
var scrollStop = function (callback) {
	// Make sure a valid callback was provided
    if (!callback || typeof callback !== 'function') return;

	// Setup scrolling variable
    var isScrolling;

	// Listen for scroll events
    window.addEventListener('scroll', function () {
		// Clear our timeout throughout the scroll
        window.clearTimeout(isScrolling);

		// Set a timeout to run after scrolling ends
        isScrolling = setTimeout(function () {
            callback();
        }, 66);
    }, false);
};

window.addEventListener('DOMContentLoaded', () => {
    let options = {
        threshold: [0.25, 0.75]
    };
    const observer = new IntersectionObserver(sections => {
        sections.forEach(section => {
            const id = section.target.getAttribute('id');
            // Need to determine a ratio that works for varying content sizes. Doesn't work if the content is too tall.
            if (section.intersectionRatio > 0.25) {
                if (id) {
                    var links = [].slice.call(document.querySelectorAll('.horizontal-nav__nav-link'));
                    links.forEach(function (link) {
                        link.setAttribute('aria-selected', 'false');
                    });

                    var intersectingLink = document.querySelector(`.horizontal-nav__nav [href="#${id}"]`);
                    if (intersectingLink) {
                        intersectingLink.setAttribute('aria-selected', 'true');
                    }
                }
            }
        });
    }, options);

    document.querySelectorAll('.experience-region [id]').forEach((section) => {
        observer.observe(section);
    });
});

scrollStop(function () {
    var intersectingLink = document.querySelector('.horizontal-nav__nav [aria-selected="true"]');
    moveNav(intersectingLink);
    // moveIndicator(intersectingLink, colours);
});

var observer = new IntersectionObserver(function (entries) {
	// no intersection with screen
    if (entries[0].intersectionRatio === 0) {
        document.querySelector('.experience-commerce_layouts-horizontalScrollNavContainer').classList.add('is-pinned');
    } /* fully intersects with screen */ else if (entries[0].intersectionRatio === 1) { document.querySelector('.experience-commerce_layouts-horizontalScrollNavContainer').classList.remove('is-pinned'); }
}, { threshold: [0, 1] });

observer.observe(document.getElementById('horizontalNavScrollObserver'));
